var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 60,
    viewBox: "0 0 69 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261153106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261153105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4766 41.2869C34.1559 41.5574 36.8622 41.2866 39.4349 40.4907L36.5047 31.0193C35.2012 31.4226 33.8299 31.5598 32.4724 31.4227C31.1148 31.2857 29.7987 30.8772 28.6021 30.2215C27.4055 29.5659 26.3528 28.6764 25.5067 27.606C25.2448 27.2747 25.0044 26.9281 24.7864 26.5684V16.0144C25.4725 14.8823 26.3729 13.8944 27.4376 13.1064C28.5344 12.2947 29.7831 11.7117 31.1095 11.3921L28.7868 1.75366C26.1688 2.38456 23.7043 3.53517 21.5397 5.13715C19.3751 6.73914 17.5545 8.75981 16.1861 11.0792C15.2872 12.6028 14.5954 14.2349 14.1258 15.9322H14.068V16.1458C13.8513 16.9637 13.6861 17.7962 13.5739 18.6386C13.2267 21.2459 13.3948 23.8955 14.068 26.4371V57.4759C14.068 58.5805 14.9634 59.4759 16.068 59.4759H16.7864C21.2047 59.4759 24.7864 55.8942 24.7864 51.4759V39.4036C26.8877 40.414 29.1514 41.0522 31.4766 41.2869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 5",
    d: "M41.3404 39.8527C46.3506 38.3324 50.5696 34.9169 53.0997 30.333C55.6298 25.7492 56.2711 20.3589 54.8871 15.3093C53.5032 10.2598 50.2033 5.9497 45.6897 3.29632C41.1761 0.642931 35.8051 -0.144237 30.72 1.10234L33.0804 10.7316C35.657 10.0999 38.3783 10.4988 40.6653 11.8432C42.9522 13.1876 44.6242 15.3714 45.3254 17.9299C46.0267 20.4884 45.7017 23.2196 44.4198 25.5421C43.1378 27.8647 41.0001 29.5952 38.4616 30.3655L41.3404 39.8527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 12",
    width: 9.37864,
    height: 30.8155,
    rx: 4.68932,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 30.8155 25.9807)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 38.1845,
    y: 25.3108,
    width: 9.37864,
    height: 30.8155,
    rx: 4.68932,
    transform: "rotate(-90 38.1845 25.3108)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark);
export default __webpack_public_path__ + "static/media/park.1b85c72741bbca32eaccac73baf31a07.svg";
export { ForwardRef as ReactComponent };